import { defineMessages } from "@/i18n";
import en from "./en";

export const framesConnectionPromptMessages = defineMessages(
  "frames-connection-prompt",
  en,
);
